<template>
  <div class="webshop text-center bg-white p-2 md:p-4 shadow-box rounded flex flex-wrap items-center">
    <a
      :href="route('frontend.clickout.click-action', clickAction.id)"
      target="_blank"
      class="block mb-1 text-center w-full"
    >
      <img
        v-if="clickAction.logo"
        :src="clickAction.logo.url"
        :alt="clickAction.name"
        :title="clickAction.name"
      >
      <span v-else>
        {{ clickAction.name }}
      </span>
    </a>

    <span class="block text-sm w-full mb-3">
      {{ clickAction.description }}
    </span>

    <span class="block text-sm text-red font-bold w-full">
      {{ clickAction.reward }}
    </span>

    <BlueOpenButton
      :href="route('frontend.clickout.click-action', clickAction.id)"
      :internal="false"
      classes="my-2 w-full"
    >
      {{ __('click-action.block.button') }}
    </BlueOpenButton>

    <div class="w-full font-bold text-red text-center">
      {{ __('click-action.block.member-clicked') }}
      <template v-if="clickAction.has_clicks">
        {{ __('click-action.block.member-clicked-yes') }}
      </template>
      <template v-else>
        {{ __('click-action.block.member-clicked-no') }}
      </template>
    </div>
  </div>
</template>

<script>
import BlueOpenButton from './Buttons/BlueOpen.vue';

export default {
  components: {BlueOpenButton},
  props: {
    clickAction: {
      type: Object,
      required: true,
    },
  },
};
</script>
